import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_CARPARKS,
  GET_CARPARK_DETAIL,
  ADD_NEW_CARPARK,
  UPDATE_CARPARK,
  DELETE_CARPARK,
  GET_CARPARK_OCCUPANCY_RATE,  
  GET_EXPORT_OCCUPANCY_RATE,  
} from "./actionTypes"
import {
  getCarParksSuccess,
  getCarParksFail,
  getCarParkDetailSuccess,
  getCarParkDetailFail,
  addCarParkFail,
  addCarParkSuccess,
  updateCarParkSuccess,
  updateCarParkFail,
  deleteCarParkSuccess,
  deleteCarParkFail,
  getOccupancyRateSuccess,
  getOccupancyRateFail,
  getExportOccupancyRateSuccess,
  getExportOccupancyRateFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getCarParks,
  getCarParkDetails,
  addNewCarPark,
  updateCarPark,
  deleteCarPark,
  getCarparkOccupancyRate,
  getExportOccupancyRate,
} from "helpers/backend_helper"

function* fetchCarParks({ payload }) {
  try {
    const response = yield call(getCarParks, payload)
    yield put(getCarParksSuccess(response))
  } catch (error) {
    yield put(getCarParksFail(error))
  }
}

function* fetchCarparkOccupancyRate({ payload }) {
  try {
    const response = yield call(getCarparkOccupancyRate, payload)
    yield put(getOccupancyRateSuccess(response))
  } catch (error) {
    yield put(getOccupancyRateFail(error))
  }
}

function* fetchCarParkDetail({ CarParkId }) {
  try {
    const response = yield call(getCarParkDetails, CarParkId)
    yield put(getCarParkDetailSuccess(response))
  } catch (error) {
    yield put(getCarParkDetailFail(error))
  }
}

function* onUpdateCarPark({ payload: CarPark }) {
  try {
    const response = yield call(updateCarPark, CarPark)
    if (response?.success) {
      yield put(updateCarParkSuccess(response))
    } else {
      yield put(updateCarParkFail(response?.message))
    }
  } catch (error) {
    yield put(updateCarParkFail(error))
  }
}

function* onAddNewCarPark({ payload: CarPark }) {
  try {
    const response = yield call(addNewCarPark, CarPark)
    if (response?.success) {
      yield put(addCarParkSuccess(response))
    } else {
      yield put(addCarParkFail(response))
    }
  } catch (error) {
    yield put(addCarParkFail(error))
  }
}

function* onDeleteCarPark({ payload: CarPark }) {
  try {
    const response = yield call(deleteCarPark, CarPark)
    if (response?.success) {
      yield put(deleteCarParkSuccess(CarPark))
    } else {
      yield put(deleteCarParkFail(response?.message))
    }
  } catch (error) {
    yield put(deleteCarParkFail(error))
  }
}

function* fetchExportOccupancyRate({ payload }) {
  try {
    const response = yield call(getExportOccupancyRate, payload)
    yield put(getExportOccupancyRateSuccess(response))
  } catch (error) {
    yield put(getExportOccupancyRateFail(error))
  }
}


function* carParkSaga() {
  yield takeEvery(GET_CARPARKS, fetchCarParks)
  yield takeEvery(GET_CARPARK_OCCUPANCY_RATE, fetchCarparkOccupancyRate)
  yield takeEvery(GET_CARPARK_DETAIL, fetchCarParkDetail)
  yield takeEvery(ADD_NEW_CARPARK, onAddNewCarPark)
  yield takeEvery(UPDATE_CARPARK, onUpdateCarPark)
  yield takeEvery(DELETE_CARPARK, onDeleteCarPark)
  yield takeEvery(GET_EXPORT_OCCUPANCY_RATE, fetchExportOccupancyRate)
}

export default carParkSaga
